/**
 * 會員端 member/period：與代理後台 agentSealCountdown 對齊，解析剩餘封盤/開獎秒數。
 */

function toInt(v) {
  const n = Number(v)
  return Number.isFinite(n) ? Math.floor(n) : null
}

export function parseTimeStringToSeconds(str) {
  if (str == null) return null
  const s = String(str).trim()
  if (!s) return null
  const parts = s.split(':').map((x) => x.trim())
  if (parts.length === 3) {
    const h = toInt(parts[0])
    const m = toInt(parts[1])
    const sec = toInt(parts[2])
    if (h == null || m == null || sec == null) return null
    return h * 3600 + m * 60 + sec
  }
  if (parts.length === 2) {
    const m = toInt(parts[0])
    const sec = toInt(parts[1])
    if (m == null || sec == null) return null
    return m * 60 + sec
  }
  return null
}

export function parseSealSecondsFromPeriod(obj) {
  if (!obj || typeof obj !== 'object') return null

  const closeMs =
    obj.closeTime != null
      ? obj.closeTime
      : obj.close_time ?? obj.sealTime ?? obj.seal_time ?? obj.nextCloseTime ?? obj.next_close_time
  const curMs =
    obj.currentTime != null
      ? obj.currentTime
      : obj.current_time ?? obj.serverTime ?? obj.server_time ?? obj.nowTime ?? obj.now_time
  if (closeMs != null && curMs != null) {
    const close = Number(closeMs)
    const cur = Number(curMs)
    if (Number.isFinite(close) && Number.isFinite(cur)) {
      const sec = Math.floor((close - cur) / 1000)
      if (sec >= 0 && sec < 86400 * 7) return sec
      if (sec < 0 && sec > -86400 * 7) return 0
    }
  }

  const drawMs =
    obj.drawTime != null
      ? obj.drawTime
      : obj.draw_time ?? obj.openTime ?? obj.open_time ?? obj.kaijiang_time ?? obj.nextDrawTime ?? obj.next_draw_time
  if (drawMs != null && curMs != null && closeMs == null) {
    const draw = Number(drawMs)
    const cur = Number(curMs)
    if (Number.isFinite(draw) && Number.isFinite(cur)) {
      const sec = Math.floor((draw - cur) / 1000)
      if (sec >= 0 && sec < 86400 * 7) return sec
      if (sec < 0 && sec > -86400 * 7) return 0
    }
  }

  const numericKeys = [
    'left_seconds',
    'leftSeconds',
    'seconds',
    'sec',
    'remaining',
    'remain',
    'countdown',
    'close_left',
    'closeLeft',
    'time_left',
    'timeLeft',
    'fengpan_left',
    'seal_left',
    'diff',
    'diff_second',
    'diffSecond',
    'lefttime',
    'LeftTime',
    'seal_seconds',
    'sealSeconds',
    'fp_time',
    'stop_time',
    'stopTime',
    'close_in',
    'closeIn',
    'to_close',
    'toClose'
  ]
  for (let i = 0; i < numericKeys.length; i++) {
    const k = numericKeys[i]
    if (obj[k] != null && obj[k] !== '') {
      const n = toInt(obj[k])
      if (n != null && n >= 0 && n < 86400 * 7) return n
    }
  }

  const nested = obj.period || obj.now || obj.current || obj.data
  if (nested && typeof nested === 'object' && nested !== obj) {
    const inner = parseSealSecondsFromPeriod(nested)
    if (inner != null) return inner
  }

  const ct = obj.close_time ?? obj.closeTime ?? obj.seal_time ?? obj.SealTime ?? obj.end_time ?? obj.endTime
  if (ct != null) {
    let t = toInt(ct)
    if (t != null) {
      if (t > 1e12) t = Math.floor(t / 1000)
      const now = Math.floor(Date.now() / 1000)
      const diff = t - now
      if (diff >= 0 && diff < 86400 * 7) return diff
    }
  }

  const strKeys = [
    'time',
    'left_time',
    'close_time_str',
    'fengpan',
    '封盘时间',
    'countdown_str',
    'kaijiang',
    'draw_time_str',
    'next_time'
  ]
  for (let i = 0; i < strKeys.length; i++) {
    const k = strKeys[i]
    if (obj[k] != null && String(obj[k]).trim() !== '') {
      const parsed = parseTimeStringToSeconds(String(obj[k]))
      if (parsed != null) return parsed
    }
  }

  return null
}
